<template>
    <div class="title-el">
        <div class="title">{{ title }}</div>
        <slot/>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String
        }
    }
}
</script>
<style lang="less" scoped>
.title-el {
    box-sizing: border-box;
    padding: 20px;
    height: 100%;
    .title {
        font-size: 16px;
        color: #fff;
    }
}
</style>